import Immutable from 'immutable';
import { DEFAULT_LANGUAGE, SITE_NAME } from '../config/constants';

export function getLanguageByPath(path, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

export function getDocumentTitle(title) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

export function getYoutubeIdFromUrl(youtubeUrl) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = youtubeUrl.match(regExp);

  return (match && match[2].length === 11)
    ? match[2]
    : null;
}

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
}

export function formatMoney(amount) {
  const currencyFormatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  return currencyFormatter.format(amount).replace(',00', ',-');
}

export function formatMoneyFromString(amount) {
  return formatMoney(parseFloat(amount));
}

export function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null ? js
    : Array.isArray(js)
      ? Immutable.Seq(js).map(fromJSOrdered).toList()
      : Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
}

/**
 * Find current url in all the alternative path aliasses to go the article page with the correct path.
 * If that path does not exist return default path alias.
 * This because the content types have multiple aliasses for the different breadcrumbs.
 */
export function getPathFromAlternativePaths(entity, url_suffix = false) {
  let url = entity.getIn(['paths', 'nl']);
  if (entity.getIn(['alternative_paths'])) {
    const alternative_paths = entity.getIn(['alternative_paths', 'nl']);
    alternative_paths.map((alternative_path) => {
      const path = alternative_path;
      if (url_suffix === false) {
        if (
          path.indexOf(`${window.location.pathname}`) > -1
        ) {
          url = alternative_path;
        }
      } else if (
        path.indexOf(`${window.location.pathname}/${url_suffix[0]}`) > -1 ||
        path.indexOf(`${window.location.pathname}/${url_suffix[1]}`) > -1
      ) {
        url = alternative_path;
      }
    });
  }
  return url;
}

export function dateFormatter(date, lang = DEFAULT_LANGUAGE) {
  return new Intl.DateTimeFormat(lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(date));
}
